import { render, staticRenderFns } from "./CompanyEditModuleMetaDataElectronischeFacturatie.vue?vue&type=template&id=e12b25e8&"
import script from "./CompanyEditModuleMetaDataElectronischeFacturatie.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataElectronischeFacturatie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e12b25e8')) {
      api.createRecord('e12b25e8', component.options)
    } else {
      api.reload('e12b25e8', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataElectronischeFacturatie.vue?vue&type=template&id=e12b25e8&", function () {
      api.rerender('e12b25e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataElectronischeFacturatie.vue"
export default component.exports